import type {
  PersonConfigurationOptionsType as ApiPersonConfigurationOptionsType,
  ReportConfigurationType as ApiReportConfigurationType,
  VenueConfigurationOptionsType as ApiVenueConfigurationOptionsType,
} from 'src/api/generated/touring/types';
import { mapPersonConfigurationOptionsType } from '../mapPersonConfigurationOptionsType';
import { mapVenueConfigurationOptionsType } from '../mapVenueConfigurationOptionsType';
import type { ReportConfigurationType } from '../../types';

const mapConfigurationOptions = (
  api: ApiVenueConfigurationOptionsType | ApiPersonConfigurationOptionsType
): ReportConfigurationType['configurationOptions'] => {
  if (api.kind === 'VENUE') {
    return mapVenueConfigurationOptionsType(api);
  }

  return mapPersonConfigurationOptionsType(api);
};

export const mapReportConfigurationType = (
  api: ApiReportConfigurationType
): ReportConfigurationType => ({
  id: api.id,
  label: api.label,
  isEnabled: api.isEnabled,
  sendWeekday: api.sendWeekday,
  sendTime: api.sendTime,
  locale: api.locale,
  configurationOptions: mapConfigurationOptions(api.configurationOptions),
  reportType: api.reportType,
  profileNote: api.profileNote,
  internalNote: api.internalNote,
});
